import { useEffect } from 'react';
import { useLocation } from 'react-router';

const NAVBAR_OFFSET = 80;

export default function ScrollToTopOnNavigate() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const scrollToHash = () => {
        const element = document.getElementById(id);
        if (element) {
          window.scrollTo({
            top: element.offsetTop - NAVBAR_OFFSET,
            left: 0,
            behavior: 'auto',
          });
          return true;
        }
        return false;
      };

      if (!scrollToHash()) {
        requestAnimationFrame(() => {
          if (!scrollToHash()) {
            window.scrollTo(0, 0);
          }
        });
      }
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
